import {ItemsState} from "@core/store/reducers/item";

export const itemCounterSelector = (state: { items: ItemsState }): ItemsState['counters'] => state.items.counters;
export const itemsSelector = (state: { items: ItemsState }): ItemsState => state.items;